module.exports = "/_next/static/images/Frame-1351f54729d25438099d3fc81fc3bc7b.webp";